import React from "react";
import { USER_PROP } from "components/User/constants";
// import appActions from "../actions";
import { useSelector } from "react-redux";
import { mobileUserSettings } from "../constants";
import { getAuthorizedRoutes } from "../Validations";
import { Link } from "react-router-dom";
import {
  Box,
  Avatar,
  Popover,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
// import { useHistory } from "react-router";
import useStyles from "../Styles";

const ToolbarButtons = () => {
  const classes = useStyles();
  //   const history = useHistory();
  const { loggedIn, role } = useSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "user-settings" : null;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { user } = useSelector((state) => state.settings.profile);
  // const { setDrawerState } = appActions();
  return (
    <>
      <Box className={classes.toolbarButtons}>
      <Avatar
            alt="Logo"
            className={classes.AvatarSmall}
            aria-describedby={id}
            onClick={handleClick}
          >
            {(user[USER_PROP.FNAME].toUpperCase()[0] || "") +
              (user[USER_PROP.LNAME].toUpperCase()[0] || "")}
          </Avatar>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <List disablePadding>
          {getAuthorizedRoutes(mobileUserSettings, loggedIn, role).map(
            (link) => (
              <ListItem
                button
                key={link.route}
                component={Link}
                to={link.route}
              >
                <ListItemText primary={link.text} />
              </ListItem>
            )
          )}
        </List>
      </Popover>
    </>
  );
};

export default ToolbarButtons;
